module.exports = "https://de18y2hs3hlxs.cloudfront.net/25e9b2d1-8359-4702-9df0-21a378808472/images/notepad.png?75405c954d83b33e90b18b75fbe7ed89";